// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Vazir/Vazirmatn-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/avenir-next/AvenirNextLTPro-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.pointer-events-none {
  pointer-events: none !important;
}
.fixed {
  position: fixed !important;
}
.absolute {
  position: absolute !important;
}
.relative {
  position: relative !important;
}
.sticky {
  position: sticky !important;
}
.-left-\\[30px\\] {
  left: -30px !important;
}
.-top-6 {
  top: -1.5rem !important;
}
.bottom-0 {
  bottom: 0px !important;
}
.bottom-0\\.5 {
  bottom: 0.125rem !important;
}
.bottom-12 {
  bottom: 3rem !important;
}
.left-0 {
  left: 0px !important;
}
.left-2 {
  left: 0.5rem !important;
}
.left-3 {
  left: 0.75rem !important;
}
.left-4 {
  left: 1rem !important;
}
.left-\\[13px\\] {
  left: 13px !important;
}
.left-\\[50\\%\\] {
  left: 50% !important;
}
.right-0 {
  right: 0px !important;
}
.right-3 {
  right: 0.75rem !important;
}
.right-4 {
  right: 1rem !important;
}
.right-5 {
  right: 1.25rem !important;
}
.right-\\[13px\\] {
  right: 13px !important;
}
.top-0 {
  top: 0px !important;
}
.top-1 {
  top: 0.25rem !important;
}
.top-1\\.5 {
  top: 0.375rem !important;
}
.top-1\\/2 {
  top: 50% !important;
}
.top-2 {
  top: 0.5rem !important;
}
.top-4 {
  top: 1rem !important;
}
.top-5 {
  top: 1.25rem !important;
}
.top-6 {
  top: 1.5rem !important;
}
.top-\\[100px\\] {
  top: 100px !important;
}
.top-\\[13px\\] {
  top: 13px !important;
}
.top-\\[1px\\] {
  top: 1px !important;
}
.top-\\[2px\\] {
  top: 2px !important;
}
.top-\\[90px\\] {
  top: 90px !important;
}
.\\!z-\\[99999999999\\] {
  z-index: 99999999999 !important;
}
.z-0 {
  z-index: 0 !important;
}
.z-10 {
  z-index: 10 !important;
}
.z-20 {
  z-index: 20 !important;
}
.z-50 {
  z-index: 50 !important;
}
.z-\\[1000\\] {
  z-index: 1000 !important;
}
.z-\\[999999999999999999\\] {
  z-index: 999999999999999999 !important;
}
.z-\\[999999999999999\\] {
  z-index: 999999999999999 !important;
}
.z-\\[999999999999\\] {
  z-index: 999999999999 !important;
}
.z-\\[999999999\\] {
  z-index: 999999999 !important;
}
.z-\\[9999999\\] {
  z-index: 9999999 !important;
}
.z-\\[9999\\] {
  z-index: 9999 !important;
}
.z-\\[999\\] {
  z-index: 999 !important;
}
.-order-1 {
  order: -1 !important;
}
.col-span-1 {
  grid-column: span 1 / span 1 !important;
}
.col-span-12 {
  grid-column: span 12 / span 12 !important;
}
.col-span-2 {
  grid-column: span 2 / span 2 !important;
}
.col-span-8 {
  grid-column: span 8 / span 8 !important;
}
.col-span-9 {
  grid-column: span 9 / span 9 !important;
}
.col-span-full {
  grid-column: 1 / -1 !important;
}
.\\!m-0 {
  margin: 0px !important;
}
.m-0 {
  margin: 0px !important;
}
.m-auto {
  margin: auto !important;
}
.mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.mx-1 {
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}
.mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}
.mx-3 {
  margin-left: 0.75rem !important;
  margin-right: 0.75rem !important;
}
.mx-4 {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}
.mx-6 {
  margin-left: 1.5rem !important;
  margin-right: 1.5rem !important;
}
.mx-\\[5px\\] {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
.my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
.my-10 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}
.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.my-5 {
  margin-top: 1.25rem !important;
  margin-bottom: 1.25rem !important;
}
.my-7 {
  margin-top: 1.75rem !important;
  margin-bottom: 1.75rem !important;
}
.my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}
.my-\\[20px\\] {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.-mt-16 {
  margin-top: -4rem !important;
}
.mb-0 {
  margin-bottom: 0px !important;
}
.mb-1 {
  margin-bottom: 0.25rem !important;
}
.mb-10 {
  margin-bottom: 2.5rem !important;
}
.mb-12 {
  margin-bottom: 3rem !important;
}
.mb-16 {
  margin-bottom: 4rem !important;
}
.mb-2 {
  margin-bottom: 0.5rem !important;
}
.mb-28 {
  margin-bottom: 7rem !important;
}
.mb-3 {
  margin-bottom: 0.75rem !important;
}
.mb-4 {
  margin-bottom: 1rem !important;
}
.mb-5 {
  margin-bottom: 1.25rem !important;
}
.mb-6 {
  margin-bottom: 1.5rem !important;
}
.mb-8 {
  margin-bottom: 2rem !important;
}
.ml-1 {
  margin-left: 0.25rem !important;
}
.ml-2 {
  margin-left: 0.5rem !important;
}
.ml-3 {
  margin-left: 0.75rem !important;
}
.ml-4 {
  margin-left: 1rem !important;
}
.ml-5 {
  margin-left: 1.25rem !important;
}
.ml-6 {
  margin-left: 1.5rem !important;
}
.ml-auto {
  margin-left: auto !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.mr-3 {
  margin-right: 0.75rem !important;
}
.mr-4 {
  margin-right: 1rem !important;
}
.mr-5 {
  margin-right: 1.25rem !important;
}
.mr-6 {
  margin-right: 1.5rem !important;
}
.mr-auto {
  margin-right: auto !important;
}
.ms-1 {
  margin-inline-start: 0.25rem !important;
}
.mt-0 {
  margin-top: 0px !important;
}
.mt-1 {
  margin-top: 0.25rem !important;
}
.mt-14 {
  margin-top: 3.5rem !important;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.mt-3 {
  margin-top: 0.75rem !important;
}
.mt-4 {
  margin-top: 1rem !important;
}
.mt-5 {
  margin-top: 1.25rem !important;
}
.mt-7 {
  margin-top: 1.75rem !important;
}
.mt-8 {
  margin-top: 2rem !important;
}
.line-clamp-3 {
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 3 !important;
}
.line-clamp-4 {
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 4 !important;
}
.\\!block {
  display: block !important;
}
.block {
  display: block !important;
}
.inline-block {
  display: inline-block !important;
}
.inline {
  display: inline !important;
}
.flex {
  display: flex !important;
}
.inline-flex {
  display: inline-flex !important;
}
.grid {
  display: grid !important;
}
.hidden {
  display: none !important;
}
.aspect-square {
  aspect-ratio: 1 / 1 !important;
}
.aspect-video {
  aspect-ratio: 16 / 9 !important;
}
.h-1 {
  height: 0.25rem !important;
}
.h-10 {
  height: 2.5rem !important;
}
.h-11 {
  height: 2.75rem !important;
}
.h-12 {
  height: 3rem !important;
}
.h-16 {
  height: 4rem !important;
}
.h-2 {
  height: 0.5rem !important;
}
.h-3 {
  height: 0.75rem !important;
}
.h-32 {
  height: 8rem !important;
}
.h-4 {
  height: 1rem !important;
}
.h-40 {
  height: 10rem !important;
}
.h-60 {
  height: 15rem !important;
}
.h-\\[200px\\] {
  height: 200px !important;
}
.h-\\[22px\\] {
  height: 22px !important;
}
.h-\\[30px\\] {
  height: 30px !important;
}
.h-\\[35px\\] {
  height: 35px !important;
}
.h-\\[36px\\] {
  height: 36px !important;
}
.h-\\[400px\\] {
  height: 400px !important;
}
.h-\\[40px\\] {
  height: 40px !important;
}
.h-\\[42px\\] {
  height: 42px !important;
}
.h-\\[49px\\] {
  height: 49px !important;
}
.h-\\[50px\\] {
  height: 50px !important;
}
.h-\\[60px\\] {
  height: 60px !important;
}
.h-\\[90vh\\] {
  height: 90vh !important;
}
.h-\\[calc\\(100vh-150px\\)\\] {
  height: calc(100vh - 150px) !important;
}
.h-auto {
  height: auto !important;
}
.h-full {
  height: 100% !important;
}
.h-screen {
  height: 100vh !important;
}
.max-h-\\[500px\\] {
  max-height: 500px !important;
}
.max-h-\\[50vh\\] {
  max-height: 50vh !important;
}
.min-h-\\[200px\\] {
  min-height: 200px !important;
}
.min-h-\\[300px\\] {
  min-height: 300px !important;
}
.min-h-\\[44px\\] {
  min-height: 44px !important;
}
.min-h-screen {
  min-height: 100vh !important;
}
.w-1 {
  width: 0.25rem !important;
}
.w-12 {
  width: 3rem !important;
}
.w-2 {
  width: 0.5rem !important;
}
.w-28 {
  width: 7rem !important;
}
.w-3\\/4 {
  width: 75% !important;
}
.w-40 {
  width: 10rem !important;
}
.w-48 {
  width: 12rem !important;
}
.w-52 {
  width: 13rem !important;
}
.w-72 {
  width: 18rem !important;
}
.w-\\[100vw\\] {
  width: 100vw !important;
}
.w-\\[10ch\\] {
  width: 10ch !important;
}
.w-\\[120px\\] {
  width: 120px !important;
}
.w-\\[15ch\\] {
  width: 15ch !important;
}
.w-\\[16ch\\] {
  width: 16ch !important;
}
.w-\\[22px\\] {
  width: 22px !important;
}
.w-\\[300px\\] {
  width: 300px !important;
}
.w-\\[35ch\\] {
  width: 35ch !important;
}
.w-fit {
  width: fit-content !important;
}
.w-full {
  width: 100% !important;
}
.w-screen {
  width: 100vw !important;
}
.min-w-0 {
  min-width: 0px !important;
}
.min-w-\\[110px\\] {
  min-width: 110px !important;
}
.min-w-\\[120px\\] {
  min-width: 120px !important;
}
.min-w-\\[12rem\\] {
  min-width: 12rem !important;
}
.min-w-\\[200px\\] {
  min-width: 200px !important;
}
.min-w-\\[220px\\] {
  min-width: 220px !important;
}
.min-w-\\[22rem\\] {
  min-width: 22rem !important;
}
.min-w-\\[260px\\] {
  min-width: 260px !important;
}
.min-w-\\[280px\\] {
  min-width: 280px !important;
}
.max-w-2xl {
  max-width: 42rem !important;
}
.max-w-6xl {
  max-width: 72rem !important;
}
.max-w-\\[1350px\\] {
  max-width: 1350px !important;
}
.max-w-\\[16rem\\] {
  max-width: 16rem !important;
}
.max-w-\\[200px\\] {
  max-width: 200px !important;
}
.max-w-\\[20ch\\] {
  max-width: 20ch !important;
}
.max-w-\\[280px\\] {
  max-width: 280px !important;
}
.max-w-\\[300px\\] {
  max-width: 300px !important;
}
.max-w-\\[30ch\\] {
  max-width: 30ch !important;
}
.max-w-\\[330px\\] {
  max-width: 330px !important;
}
.max-w-\\[35ch\\] {
  max-width: 35ch !important;
}
.max-w-\\[40ch\\] {
  max-width: 40ch !important;
}
.max-w-lg {
  max-width: 32rem !important;
}
.max-w-md {
  max-width: 28rem !important;
}
.max-w-sm {
  max-width: 24rem !important;
}
.max-w-xl {
  max-width: 36rem !important;
}
.max-w-xs {
  max-width: 20rem !important;
}
.flex-1 {
  flex: 1 1 !important;
}
.flex-shrink-0 {
  flex-shrink: 0 !important;
}
.shrink-0 {
  flex-shrink: 0 !important;
}
.flex-grow {
  flex-grow: 1 !important;
}
.flex-grow-0 {
  flex-grow: 0 !important;
}
.grow {
  flex-grow: 1 !important;
}
.-translate-x-\\[50\\%\\] {
  --tw-translate-x: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180 {
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-x-\\[-1\\] {
  --tw-scale-x: -1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite !important;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite !important;
}
.cursor-auto {
  cursor: auto !important;
}
.cursor-not-allowed {
  cursor: not-allowed !important;
}
.cursor-pointer {
  cursor: pointer !important;
}
.select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}
.resize {
  resize: both !important;
}
.snap-y {
  scroll-snap-type: y var(--tw-scroll-snap-strictness) !important;
}
.snap-start {
  scroll-snap-align: start !important;
}
.grid-flow-row {
  grid-auto-flow: row !important;
}
.grid-flow-col {
  grid-auto-flow: column !important;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
}
.flex-row {
  flex-direction: row !important;
}
.flex-col {
  flex-direction: column !important;
}
.flex-col-reverse {
  flex-direction: column-reverse !important;
}
.flex-wrap {
  flex-wrap: wrap !important;
}
.flex-nowrap {
  flex-wrap: nowrap !important;
}
.items-start {
  align-items: flex-start !important;
}
.items-end {
  align-items: flex-end !important;
}
.items-center {
  align-items: center !important;
}
.items-stretch {
  align-items: stretch !important;
}
.justify-start {
  justify-content: flex-start !important;
}
.justify-end {
  justify-content: flex-end !important;
}
.justify-center {
  justify-content: center !important;
}
.justify-between {
  justify-content: space-between !important;
}
.justify-around {
  justify-content: space-around !important;
}
.justify-stretch {
  justify-content: stretch !important;
}
.gap-1 {
  gap: 0.25rem !important;
}
.gap-10 {
  gap: 2.5rem !important;
}
.gap-12 {
  gap: 3rem !important;
}
.gap-2 {
  gap: 0.5rem !important;
}
.gap-3 {
  gap: 0.75rem !important;
}
.gap-4 {
  gap: 1rem !important;
}
.gap-5 {
  gap: 1.25rem !important;
}
.gap-6 {
  gap: 1.5rem !important;
}
.gap-7 {
  gap: 1.75rem !important;
}
.gap-8 {
  gap: 2rem !important;
}
.gap-x-1 {
  column-gap: 0.25rem !important;
}
.gap-x-10 {
  column-gap: 2.5rem !important;
}
.gap-x-12 {
  column-gap: 3rem !important;
}
.gap-x-2 {
  column-gap: 0.5rem !important;
}
.gap-x-3 {
  column-gap: 0.75rem !important;
}
.gap-x-4 {
  column-gap: 1rem !important;
}
.gap-x-5 {
  column-gap: 1.25rem !important;
}
.gap-x-7 {
  column-gap: 1.75rem !important;
}
.gap-x-8 {
  column-gap: 2rem !important;
}
.gap-y-10 {
  row-gap: 2.5rem !important;
}
.gap-y-2 {
  row-gap: 0.5rem !important;
}
.gap-y-3 {
  row-gap: 0.75rem !important;
}
.gap-y-4 {
  row-gap: 1rem !important;
}
.gap-y-5 {
  row-gap: 1.25rem !important;
}
.gap-y-8 {
  row-gap: 2rem !important;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse)) !important;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse)) !important;
}
.self-start {
  align-self: flex-start !important;
}
.overflow-hidden {
  overflow: hidden !important;
}
.overflow-x-auto {
  overflow-x: auto !important;
}
.overflow-y-auto {
  overflow-y: auto !important;
}
.overflow-x-scroll {
  overflow-x: scroll !important;
}
.overflow-ellipsis {
  text-overflow: ellipsis !important;
}
.whitespace-nowrap {
  white-space: nowrap !important;
}
.whitespace-pre-line {
  white-space: pre-line !important;
}
.break-all {
  word-break: break-all !important;
}
.rounded {
  border-radius: 0.25rem !important;
}
.rounded-2xl {
  border-radius: 1rem !important;
}
.rounded-full {
  border-radius: 9999px !important;
}
.rounded-lg {
  border-radius: 0.5rem !important;
}
.rounded-md {
  border-radius: 0.375rem !important;
}
.rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded-t-\\[4rem\\] {
  border-top-left-radius: 4rem !important;
  border-top-right-radius: 4rem !important;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem !important;
  border-top-right-radius: 0.75rem !important;
}
.rounded-bl-none {
  border-bottom-left-radius: 0px !important;
}
.rounded-br-none {
  border-bottom-right-radius: 0px !important;
}
.rounded-tl-none {
  border-top-left-radius: 0px !important;
}
.rounded-tr-none {
  border-top-right-radius: 0px !important;
}
.border {
  border-width: 1px !important;
}
.border-0 {
  border-width: 0px !important;
}
.border-2 {
  border-width: 2px !important;
}
.border-4 {
  border-width: 4px !important;
}
.border-b {
  border-bottom-width: 1px !important;
}
.border-b-0 {
  border-bottom-width: 0px !important;
}
.border-l {
  border-left-width: 1px !important;
}
.border-r-\\[3px\\] {
  border-right-width: 3px !important;
}
.border-t {
  border-top-width: 1px !important;
}
.border-dashed {
  border-style: dashed !important;
}
.border-\\[var\\(--dg-border-color\\)\\] {
  border-color: var(--dg-border-color) !important;
}
.border-\\[var\\(--dg-opposite-color\\)\\] {
  border-color: var(--dg-opposite-color) !important;
}
.border-\\[var\\(--dg-orange-color\\)\\] {
  border-color: var(--dg-orange-color) !important;
}
.border-\\[var\\(--dg-primary-color\\)\\] {
  border-color: var(--dg-primary-color) !important;
}
.border-\\[var\\(--dg-white-color\\)\\] {
  border-color: var(--dg-white-color) !important;
}
.border-dg-green-color {
  border-color: var(--dg-green-color) !important;
}
.border-dg-info-color {
  border-color: var(--dg-info-color) !important;
}
.border-dg-opposite-primary-color {
  border-color: var(--dg-opposite-primary-color) !important;
}
.border-dg-primary-color {
  border-color: var(--dg-primary-color) !important;
}
.border-dg-red-color {
  border-color: var(--dg-red-color) !important;
}
.border-dg-wallet-button {
  border-color: var(--dg-wallet-button) !important;
}
.border-transparent {
  border-color: transparent !important;
}
.border-b-\\[var\\(--dg-border-color\\)\\] {
  border-bottom-color: var(--dg-border-color) !important;
}
.border-b-dg-border-color {
  border-bottom-color: var(--dg-border-color) !important;
}
.border-b-dg-filter-border-color {
  border-bottom-color: var(--dg-filter-border-color) !important;
}
.border-b-transparent {
  border-bottom-color: transparent !important;
}
.border-t-\\[var\\(--dg-border-color\\)\\] {
  border-top-color: var(--dg-border-color) !important;
}
.bg-\\[\\#58a0f8\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(88 160 248 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#ffc800\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 200 0 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[var\\(--dg-body-bg\\)\\] {
  background-color: var(--dg-body-bg) !important;
}
.bg-\\[var\\(--dg-body-bg-light\\)\\] {
  background-color: var(--dg-body-bg-light) !important;
}
.bg-\\[var\\(--dg-card-bg-1\\)\\] {
  background-color: var(--dg-card-bg-1) !important;
}
.bg-\\[var\\(--dg-card-bg-2\\)\\] {
  background-color: var(--dg-card-bg-2) !important;
}
.bg-\\[var\\(--dg-card-bg-3\\)\\] {
  background-color: var(--dg-card-bg-3) !important;
}
.bg-\\[var\\(--dg-gray-color-2\\)\\] {
  background-color: var(--dg-gray-color-2) !important;
}
.bg-\\[var\\(--dg-green-color\\)\\] {
  background-color: var(--dg-green-color) !important;
}
.bg-\\[var\\(--dg-info-color\\)\\] {
  background-color: var(--dg-info-color) !important;
}
.bg-\\[var\\(--dg-input-bg\\)\\] {
  background-color: var(--dg-input-bg) !important;
}
.bg-\\[var\\(--dg-loading-bg\\)\\] {
  background-color: var(--dg-loading-bg) !important;
}
.bg-\\[var\\(--dg-opposite-color\\)\\] {
  background-color: var(--dg-opposite-color) !important;
}
.bg-\\[var\\(--dg-orange-color\\)\\] {
  background-color: var(--dg-orange-color) !important;
}
.bg-\\[var\\(--dg-primary-color\\)\\] {
  background-color: var(--dg-primary-color) !important;
}
.bg-\\[var\\(--dg-primary-color-fixed\\)\\] {
  background-color: var(--dg-primary-color-fixed) !important;
}
.bg-\\[var\\(--dg-primary-color-hover\\)\\] {
  background-color: var(--dg-primary-color-hover) !important;
}
.bg-\\[var\\(--dg-primary-color-light-hover-3\\)\\] {
  background-color: var(--dg-primary-color-light-hover-3) !important;
}
.bg-\\[var\\(--dg-purple-color\\)\\] {
  background-color: var(--dg-purple-color) !important;
}
.bg-\\[var\\(--dg-red-color\\)\\] {
  background-color: var(--dg-red-color) !important;
}
.bg-\\[var\\(--dg-red-color-2\\)\\] {
  background-color: var(--dg-red-color-2) !important;
}
.bg-\\[var\\(--dg-secondary-color\\)\\] {
  background-color: var(--dg-secondary-color) !important;
}
.bg-\\[var\\(--dg-white-color\\)\\] {
  background-color: var(--dg-white-color) !important;
}
.bg-cyan-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 211 238 / var(--tw-bg-opacity, 1)) !important;
}
.bg-dg-card-bg-1 {
  background-color: var(--dg-card-bg-1) !important;
}
.bg-dg-card-bg-3 {
  background-color: var(--dg-card-bg-3) !important;
}
.bg-dg-dropdown-bg {
  background-color: var(--dg-dropdown-bg) !important;
}
.bg-dg-filter-body-bg {
  background-color: var(--dg-filter-body-bg) !important;
}
.bg-dg-filter-body-bg-hover {
  background-color: var(--dg-filter-body-bg-hover) !important;
}
.bg-dg-green-color {
  background-color: var(--dg-green-color) !important;
}
.bg-dg-info-color {
  background-color: var(--dg-info-color) !important;
}
.bg-dg-orange-color {
  background-color: var(--dg-orange-color) !important;
}
.bg-dg-red-color-2 {
  background-color: var(--dg-red-color-2) !important;
}
.bg-dg-secondary-color {
  background-color: var(--dg-secondary-color) !important;
}
.bg-dg-wallet-button {
  background-color: var(--dg-wallet-button) !important;
}
.bg-dg-white-color {
  background-color: var(--dg-white-color) !important;
}
.bg-gray-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1)) !important;
}
.bg-green-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1)) !important;
}
.bg-header-bg {
  background-color: var(--header-bg) !important;
}
.bg-slate-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1)) !important;
}
.bg-transparent {
  background-color: transparent !important;
}
.bg-yellow-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1)) !important;
}
.object-cover {
  object-fit: cover !important;
}
.p-0 {
  padding: 0px !important;
}
.p-1\\.5 {
  padding: 0.375rem !important;
}
.p-12 {
  padding: 3rem !important;
}
.p-2 {
  padding: 0.5rem !important;
}
.p-3 {
  padding: 0.75rem !important;
}
.p-4 {
  padding: 1rem !important;
}
.p-5 {
  padding: 1.25rem !important;
}
.p-6 {
  padding: 1.5rem !important;
}
.px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-5 {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.px-7 {
  padding-left: 1.75rem !important;
  padding-right: 1.75rem !important;
}
.px-8 {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.px-\\[10px\\] {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.py-1\\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-2\\.5 {
  padding-top: 0.625rem !important;
  padding-bottom: 0.625rem !important;
}
.py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.py-7 {
  padding-top: 1.75rem !important;
  padding-bottom: 1.75rem !important;
}
.py-\\[10px\\] {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.pb-1 {
  padding-bottom: 0.25rem !important;
}
.pb-12 {
  padding-bottom: 3rem !important;
}
.pb-2 {
  padding-bottom: 0.5rem !important;
}
.pb-3 {
  padding-bottom: 0.75rem !important;
}
.pb-4 {
  padding-bottom: 1rem !important;
}
.pb-5 {
  padding-bottom: 1.25rem !important;
}
.pb-6 {
  padding-bottom: 1.5rem !important;
}
.pb-8 {
  padding-bottom: 2rem !important;
}
.pb-\\[10px\\] {
  padding-bottom: 10px !important;
}
.pl-2 {
  padding-left: 0.5rem !important;
}
.pl-8 {
  padding-left: 2rem !important;
}
.pt-1 {
  padding-top: 0.25rem !important;
}
.pt-3 {
  padding-top: 0.75rem !important;
}
.pt-4 {
  padding-top: 1rem !important;
}
.pt-5 {
  padding-top: 1.25rem !important;
}
.pt-6 {
  padding-top: 1.5rem !important;
}
.pt-\\[10px\\] {
  padding-top: 10px !important;
}
.text-left {
  text-align: left !important;
}
.text-center {
  text-align: center !important;
}
.text-right {
  text-align: right !important;
}
.text-justify {
  text-align: justify !important;
}
.align-middle {
  vertical-align: middle !important;
}
.text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.text-3xl {
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.text-5xl {
  font-size: 3rem !important;
  line-height: 1 !important;
}
.text-\\[0\\.92rem\\] {
  font-size: 0.92rem !important;
}
.text-\\[10px\\] {
  font-size: 10px !important;
}
.text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.text-sm {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-xl {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.font-bold {
  font-weight: 700 !important;
}
.font-extrabold {
  font-weight: 800 !important;
}
.font-medium {
  font-weight: 500 !important;
}
.leading-tight {
  line-height: 1.25 !important;
}
.text-\\[var\\(--dg-disabled-color-light\\)\\] {
  color: var(--dg-disabled-color-light) !important;
}
.text-\\[var\\(--dg-green-color\\)\\] {
  color: var(--dg-green-color) !important;
}
.text-\\[var\\(--dg-green-color-hover\\)\\] {
  color: var(--dg-green-color-hover) !important;
}
.text-\\[var\\(--dg-info-color\\)\\] {
  color: var(--dg-info-color) !important;
}
.text-\\[var\\(--dg-opposite-color\\)\\] {
  color: var(--dg-opposite-color) !important;
}
.text-\\[var\\(--dg-orange-color\\)\\] {
  color: var(--dg-orange-color) !important;
}
.text-\\[var\\(--dg-primary-color\\)\\] {
  color: var(--dg-primary-color) !important;
}
.text-\\[var\\(--dg-primary-color-fixed\\)\\] {
  color: var(--dg-primary-color-fixed) !important;
}
.text-\\[var\\(--dg-primary-color-pale\\)\\] {
  color: var(--dg-primary-color-pale) !important;
}
.text-\\[var\\(--dg-red-color-2\\)\\] {
  color: var(--dg-red-color-2) !important;
}
.text-\\[var\\(--dg-white-color\\)\\] {
  color: var(--dg-white-color) !important;
}
.text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-dg-green-color {
  color: var(--dg-green-color) !important;
}
.text-dg-info-color {
  color: var(--dg-info-color) !important;
}
.text-dg-opposite-primary-color {
  color: var(--dg-opposite-primary-color) !important;
}
.text-dg-orange-color {
  color: var(--dg-orange-color) !important;
}
.text-dg-primary-color {
  color: var(--dg-primary-color) !important;
}
.text-dg-primary-color-light {
  color: var(--dg-primary-color-light) !important;
}
.text-dg-red-color {
  color: var(--dg-red-color) !important;
}
.text-dg-white-color {
  color: var(--dg-white-color) !important;
}
.text-inherit {
  color: inherit !important;
}
.text-red-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1)) !important;
}
.text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.underline {
  text-decoration-line: underline !important;
}
.line-through {
  text-decoration-line: line-through !important;
}
.opacity-100 {
  opacity: 1 !important;
}
.opacity-50 {
  opacity: 0.5 !important;
}
.opacity-75 {
  opacity: 0.75 !important;
}
.opacity-80 {
  opacity: 0.8 !important;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0px_0px_2px\\] {
  --tw-shadow: 0px 0px 2px !important;
  --tw-shadow-colored: 0px 0px 2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0px_2px_12px\\] {
  --tw-shadow: 0px 2px 12px !important;
  --tw-shadow-colored: 0px 2px 12px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-dg-header-shadow {
  --tw-shadow-color: var(--dg-header-shadow) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.shadow-dg-opposite-primary-color {
  --tw-shadow-color: var(--dg-opposite-primary-color) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.outline {
  outline-style: solid !important;
}
.blur {
  --tw-blur: blur(8px) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-all {
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.duration-300 {
  transition-duration: 300ms !important;
}
.duration-\\[0\\.3s\\] {
  transition-duration: 0.3s !important;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
.ms-1 {
  margin-inline-start: 0.25rem !important;
}
.striped td {
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1)) !important;
  --tw-bg-opacity: 0.2 !important;
}

.ant-popover-inner-content,
.ant-popover-content,
.ant-popover {
  max-width: 280px !important;
  width: 100% !important;
}

* {
  outline: none;
  padding: 0;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.5) transparent;
  font-family: "AvenirNext", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[dir=rtl] * {
  font-family: "Vazir", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

*::-webkit-scrollbar {
  width: 6px;
  height: 5px;
}

*::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 5px;
}

*::-webkit-scrollbar-thumb {
  background-color: rgba(134, 134, 134, 0.5);
  border-radius: 5px;
  border: transparent;
}

@font-face {
  font-family: "Vazir";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "AvenirNext";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
body {
  margin: 0;
  background-color: var(--dg-body-bg) !important;
  overflow-x: hidden;
  color: var(--dg-primary-color);
}

a {
  color: inherit;
  transition: unset;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--dg-text-color) !important;
}

h1 {
  display: block;
  font-size: 2em;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

h2 {
  display: block;
  font-size: 1.5em;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

h3 {
  display: block;
  font-size: 1.17em;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

h4 {
  display: block;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

h5 {
  display: block;
  font-size: 0.83em;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

h6 {
  display: block;
  font-size: 0.67em;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

.rtl {
  direction: rtl !important;
}

.rtl-all * {
  direction: rtl !important;
}

.ltr {
  direction: ltr !important;
}

.ltr-all * {
  direction: ltr !important;
}

/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--dg-primary-color) !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  -webkit-transition: background-color 5000s ease-in-out 0s !important;
  transition: background-color 5000s ease-in-out 0s !important;
}

/* disable password input suggest */
.dg-input-password {
  font-family: text-security-disc;
  text-security: disc;
  -webkit-text-security: disc;
  -moz-text-security: disc;
}

/* date picker */
.rmdp-container {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  border-radius: 16px;
  padding: 4px 11px;
  color: var(--dg-primary-color);
  font-size: 14px;
  background-color: var(--dg-input-bg);
  background-image: none;
  border: 1px solid var(--dg-input-border-color);
  border-radius: 0.375rem;
  transition: all 0.3s;
}

/* container */
.container {
  margin-left: auto;
  margin-right: auto;
  max-width: 1368px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.anticon-eye-invisible,
.anticon-eye.ant-input-password-icon {
  color: var(--dg-text-color) !important;
}

.rmdp-top-class,
.rmdp-container .bg-dark.ep-arrow::after,
.bg-dark.rmdp-wrapper,
.bg-dark .rmdp-month-picker,
.bg-dark .rmdp-year-picker,
.bg-dark .rmdp-time-picker div input {
  background-color: var(--dg-input-bg) !important;
  box-shadow: 0 0 8px 1px #ccc;
}

.rmdp-top-class,
.bg-dark.rmdp-wrapper {
  border-radius: 16px;
}

.rmdp-ep-shadow:after {
  box-shadow: none !important;
}

.rmdp-container {
  height: 50px !important;
}

/* sidebar */
.responsive-layout {
  width: 100%;
}

@media (min-width: 969px) {
  .responsive-layout {
    width: calc(96vw - 282px);
  }
}
@media (min-width: 1643px) {
  .responsive-layout {
    width: 100%;
  }
}
/* toast */
.Toastify__toast-container {
  z-index: 100000000000000000000 !important;
}

/* modal */
.ant-modal-mask {
  z-index: 999999999 !important;
}

.ant-modal-wrap {
  z-index: 99999999999 !important;
}

#lottie {
  background-color: transparent;
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  text-align: center;
  opacity: 1;
}

/* crisp */
#crisp-chatbox {
  z-index: 10000000000000000000000000000000000000;
}

.swiper-slide-shadow-coverflow {
  display: none !important;
}

.before\\:absolute::before {
  content: var(--tw-content) !important;
  position: absolute !important;
}

.before\\:top-1\\/2::before {
  content: var(--tw-content) !important;
  top: 50% !important;
}

.before\\:h-4\\/5::before {
  content: var(--tw-content) !important;
  height: 80% !important;
}

.before\\:-translate-y-1\\/2::before {
  content: var(--tw-content) !important;
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.before\\:rounded-full::before {
  content: var(--tw-content) !important;
  border-radius: 9999px !important;
}

.before\\:border-l-4::before {
  content: var(--tw-content) !important;
  border-left-width: 4px !important;
}

.before\\:border-l-\\[16px\\]::before {
  content: var(--tw-content) !important;
  border-left-width: 16px !important;
}

.before\\:border-\\[var\\(--dg-primary-color\\)\\]::before {
  content: var(--tw-content) !important;
  border-color: var(--dg-primary-color) !important;
}

.before\\:opacity-0::before {
  content: var(--tw-content) !important;
  opacity: 0 !important;
}

.after\\:absolute::after {
  content: var(--tw-content) !important;
  position: absolute !important;
}

.after\\:left-0::after {
  content: var(--tw-content) !important;
  left: 0px !important;
}

.after\\:top-0::after {
  content: var(--tw-content) !important;
  top: 0px !important;
}

.after\\:h-full::after {
  content: var(--tw-content) !important;
  height: 100% !important;
}

.after\\:w-2::after {
  content: var(--tw-content) !important;
  width: 0.5rem !important;
}

.after\\:bg-\\[var\\(--dg-orange-color\\)\\]::after {
  content: var(--tw-content) !important;
  background-color: var(--dg-orange-color) !important;
}

.last\\:border-0:last-child {
  border-width: 0px !important;
}

.last\\:border-b-0:last-child {
  border-bottom-width: 0px !important;
}

.hover\\:border-b:hover {
  border-bottom-width: 1px !important;
}

.hover\\:border-dg-wallet-button-hover:hover {
  border-color: var(--dg-wallet-button-hover) !important;
}

.hover\\:border-b-\\[var\\(--dg-primary-color\\)\\]:hover {
  border-bottom-color: var(--dg-primary-color) !important;
}

.hover\\:border-b-\\[var\\(--dg-primary-color-hover\\)\\]:hover {
  border-bottom-color: var(--dg-primary-color-hover) !important;
}

.hover\\:bg-\\[var\\(--dg-card-bg-2\\)\\]:hover {
  background-color: var(--dg-card-bg-2) !important;
}

.hover\\:bg-\\[var\\(--dg-card-bg-3\\)\\]:hover {
  background-color: var(--dg-card-bg-3) !important;
}

.hover\\:bg-\\[var\\(--dg-primary-color-light-hover-3\\)\\]:hover {
  background-color: var(--dg-primary-color-light-hover-3) !important;
}

.hover\\:bg-dg-filter-body-bg-hover:hover {
  background-color: var(--dg-filter-body-bg-hover) !important;
}

.hover\\:bg-dg-orange-color-hover:hover {
  background-color: var(--dg-orange-color-hover) !important;
}

.hover\\:bg-dg-red-color-hover:hover {
  background-color: var(--dg-red-color-hover) !important;
}

.hover\\:bg-dg-wallet-button-hover:hover {
  background-color: var(--dg-wallet-button-hover) !important;
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:text-\\[var\\(--dg-primary-color\\)\\]:hover {
  color: var(--dg-primary-color) !important;
}

.hover\\:text-\\[var\\(--dg-primary-color-hover\\)\\]:hover {
  color: var(--dg-primary-color-hover) !important;
}

.hover\\:text-dg-primary-color:hover {
  color: var(--dg-primary-color) !important;
}

.hover\\:underline:hover {
  text-decoration-line: underline !important;
}

.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.group:hover .group-hover\\:flex {
  display: flex !important;
}

.group:hover .group-hover\\:grid {
  display: grid !important;
}

.group:hover .group-hover\\:bg-\\[var\\(--dg-card-bg-2\\)\\] {
  background-color: var(--dg-card-bg-2) !important;
}

.group:hover .group-hover\\:text-\\[var\\(--dg-primary-color\\)\\] {
  color: var(--dg-primary-color) !important;
}

.group:hover .group-hover\\:before\\:opacity-100::before {
  content: var(--tw-content) !important;
  opacity: 1 !important;
}

.dark\\:bg-\\[var\\(--dg-body-bg\\)\\]:is(.dark *) {
  background-color: var(--dg-body-bg) !important;
}

.dark\\:bg-\\[var\\(--dg-card-bg-2\\)\\]:is(.dark *) {
  background-color: var(--dg-card-bg-2) !important;
}

.dark\\:bg-\\[var\\(--dg-opposite-primary-color\\)\\]:is(.dark *) {
  background-color: var(--dg-opposite-primary-color) !important;
}

.dark\\:bg-\\[var\\(--dg-primary-color-hover\\)\\]:is(.dark *) {
  background-color: var(--dg-primary-color-hover) !important;
}

.dark\\:bg-dg-card-bg-1:is(.dark *) {
  background-color: var(--dg-card-bg-1) !important;
}

.dark\\:bg-dg-card-bg-3:is(.dark *) {
  background-color: var(--dg-card-bg-3) !important;
}

.dark\\:text-\\[var\\(--dg-orange-color\\)\\]:is(.dark *) {
  color: var(--dg-orange-color) !important;
}

.dark\\:text-\\[var\\(--dg-primary-color\\)\\]:is(.dark *) {
  color: var(--dg-primary-color) !important;
}

.dark\\:text-\\[var\\(--dg-primary-color-light-hover-2\\)\\]:is(.dark *) {
  color: var(--dg-primary-color-light-hover-2) !important;
}

.dark\\:text-dg-primary-color-light-hover-2:is(.dark *) {
  color: var(--dg-primary-color-light-hover-2) !important;
}

.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.dark\\:hover\\:bg-\\[var\\(--dg-primary-color-hover\\)\\]:hover:is(.dark *) {
  background-color: var(--dg-primary-color-hover) !important;
}

@media (min-width: 475px) {

  .xs\\:mx-4 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  .xs\\:my-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }

  .xs\\:mb-0 {
    margin-bottom: 0px !important;
  }

  .xs\\:block {
    display: block !important;
  }

  .xs\\:h-\\[40px\\] {
    height: 40px !important;
  }

  .xs\\:h-\\[calc\\(100vh-90px\\)\\] {
    height: calc(100vh - 90px) !important;
  }

  .xs\\:h-\\[calc\\(100vh_-_90px\\)\\] {
    height: calc(100vh - 90px) !important;
  }

  .xs\\:w-\\[25ch\\] {
    width: 25ch !important;
  }

  .xs\\:w-auto {
    width: auto !important;
  }

  .xs\\:max-w-full {
    max-width: 100% !important;
  }

  .xs\\:break-before-auto {
    page-break-before: auto !important;
    break-before: auto !important;
  }

  .xs\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .xs\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .xs\\:flex-row {
    flex-direction: row !important;
  }

  .xs\\:items-center {
    align-items: center !important;
  }

  .xs\\:justify-between {
    justify-content: space-between !important;
  }

  .xs\\:gap-5 {
    gap: 1.25rem !important;
  }

  .xs\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0px * var(--tw-space-y-reverse)) !important;
  }

  .xs\\:p-1 {
    padding: 0.25rem !important;
  }

  .xs\\:px-12 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  .xs\\:px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .xs\\:px-7 {
    padding-left: 1.75rem !important;
    padding-right: 1.75rem !important;
  }
}

@media (min-width: 500px) {

  .lg-500\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media (min-width: 600px) {

  .lg-600\\:flex-row {
    flex-direction: row !important;
  }
}

@media (min-width: 640px) {

  .sm\\:col-span-3 {
    grid-column: span 3 / span 3 !important;
  }

  .sm\\:col-span-5 {
    grid-column: span 5 / span 5 !important;
  }

  .sm\\:mb-7 {
    margin-bottom: 1.75rem !important;
  }

  .sm\\:mr-4 {
    margin-right: 1rem !important;
  }

  .sm\\:w-96 {
    width: 24rem !important;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .sm\\:flex-row {
    flex-direction: row !important;
  }

  .sm\\:gap-5 {
    gap: 1.25rem !important;
  }

  .sm\\:gap-y-3 {
    row-gap: 0.75rem !important;
  }

  .sm\\:self-center {
    align-self: center !important;
  }

  .sm\\:border-r {
    border-right-width: 1px !important;
  }

  .sm\\:p-0 {
    padding: 0px !important;
  }

  .sm\\:p-5 {
    padding: 1.25rem !important;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  .sm\\:py-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .sm\\:pb-10 {
    padding-bottom: 2.5rem !important;
  }

  .sm\\:pr-4 {
    padding-right: 1rem !important;
  }

  .sm\\:pt-6 {
    padding-top: 1.5rem !important;
  }

  .sm\\:text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }
}

@media (min-width: 768px) {

  .md\\:bottom-0 {
    bottom: 0px !important;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }

  .md\\:col-span-5 {
    grid-column: span 5 / span 5 !important;
  }

  .md\\:mb-0 {
    margin-bottom: 0px !important;
  }

  .md\\:mb-2 {
    margin-bottom: 0.5rem !important;
  }

  .md\\:block {
    display: block !important;
  }

  .md\\:flex {
    display: flex !important;
  }

  .md\\:grid {
    display: grid !important;
  }

  .md\\:hidden {
    display: none !important;
  }

  .md\\:w-\\[600px\\] {
    width: 600px !important;
  }

  .md\\:max-w-\\[200px\\] {
    max-width: 200px !important;
  }

  .md\\:max-w-xs {
    max-width: 20rem !important;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
  }

  .md\\:flex-row {
    flex-direction: row !important;
  }

  .md\\:items-center {
    align-items: center !important;
  }

  .md\\:justify-end {
    justify-content: flex-end !important;
  }

  .md\\:justify-between {
    justify-content: space-between !important;
  }

  .md\\:gap-0 {
    gap: 0px !important;
  }

  .md\\:gap-1 {
    gap: 0.25rem !important;
  }

  .md\\:gap-8 {
    gap: 2rem !important;
  }

  .md\\:gap-y-4 {
    row-gap: 1rem !important;
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0px * var(--tw-space-y-reverse)) !important;
  }

  .md\\:whitespace-nowrap {
    white-space: nowrap !important;
  }

  .md\\:border-b {
    border-bottom-width: 1px !important;
  }

  .md\\:p-4 {
    padding: 1rem !important;
  }

  .md\\:px-5 {
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }

  .md\\:py-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .md\\:text-right {
    text-align: right !important;
  }

  .md\\:text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }

  .md\\:text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }
}

@media (min-width: 969px) {

  .lg-969\\:mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .lg-969\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
  }

  .lg-969\\:flex-row {
    flex-direction: row !important;
  }
}

@media (min-width: 1024px) {

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1 !important;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3 !important;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5 !important;
  }

  .lg\\:block {
    display: block !important;
  }

  .lg\\:w-\\[330px\\] {
    width: 330px !important;
  }

  .lg\\:w-auto {
    width: auto !important;
  }

  .lg\\:max-w-none {
    max-width: none !important;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  }

  .lg\\:flex-row {
    flex-direction: row !important;
  }

  .lg\\:justify-end {
    justify-content: flex-end !important;
  }

  .lg\\:justify-between {
    justify-content: space-between !important;
  }

  .lg\\:p-10 {
    padding: 2.5rem !important;
  }

  .lg\\:px-7 {
    padding-left: 1.75rem !important;
    padding-right: 1.75rem !important;
  }
}

@media (min-width: 1200px) {

  .lg-1200\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .lg-1200\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
}

@media (min-width: 1300px) {

  .lg-1300\\:mt-0 {
    margin-top: 0px !important;
  }

  .lg-1300\\:w-1\\/2 {
    width: 50% !important;
  }

  .lg-1300\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .lg-1300\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .lg-1300\\:flex-row {
    flex-direction: row !important;
  }

  .lg-1300\\:items-center {
    align-items: center !important;
  }
}

.ltr\\:border-r:where([dir="ltr"], [dir="ltr"] *) {
  border-right-width: 1px !important;
}

.ltr\\:text-left:where([dir="ltr"], [dir="ltr"] *) {
  text-align: left !important;
}

.ltr\\:text-right:where([dir="ltr"], [dir="ltr"] *) {
  text-align: right !important;
}

.ltr\\:before\\:left-0:where([dir="ltr"], [dir="ltr"] *)::before {
  content: var(--tw-content) !important;
  left: 0px !important;
}

.rtl\\:mr-3:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: 0.75rem !important;
}

.rtl\\:rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.rtl\\:justify-end:where([dir="rtl"], [dir="rtl"] *) {
  justify-content: flex-end !important;
}

.rtl\\:border-l:where([dir="rtl"], [dir="rtl"] *) {
  border-left-width: 1px !important;
}

.rtl\\:text-left:where([dir="rtl"], [dir="rtl"] *) {
  text-align: left !important;
}

.rtl\\:text-right:where([dir="rtl"], [dir="rtl"] *) {
  text-align: right !important;
}

.rtl\\:before\\:right-0:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content) !important;
  right: 0px !important;
}

.rtl\\:after\\:right-0:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content) !important;
  right: 0px !important;
}

@media print {

  .print\\:block {
    display: block !important;
  }

  .print\\:hidden {
    display: none !important;
  }
}

.\\[\\&\\>\\.swiper-button-next\\]\\:\\!text-white>.swiper-button-next {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.\\[\\&\\>\\.swiper-button-prev\\]\\:\\!text-white>.swiper-button-prev {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.\\[\\&\\>\\.swiper-pagination\\]\\:\\!text-white>.swiper-pagination {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/index.scss"],"names":[],"mappings":"AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AAEA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,+BAAA;EAAA,uCAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,+BAAA;EAAA,uCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,2BAAA;IAAA;EAAA;;EAAA;IAAA,eAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA,yEAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA,0EAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA,uEAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA,0EAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,qFAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,0FAAA;EAAA,8GAAA;EAAA;AAAA;AAAA;EAAA,wFAAA;EAAA,4GAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,qDAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,6GAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,mKAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,0GAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAIE;EAAA,iEAAA;EAAA;AAAA;;AAIF;;;EAIC,2BAAA;EACA,sBAAA;AAHD;;AAMA;EACC,aAAA;EACA,UAAA;EACA,sBAAA;EACA,qBAAA;EACA,qDAAA;EACA,4KAAA;EAGA,mCAAA;EACA,kCAAA;AALD;;AAQA;EACC,uKAAA;AALD;;AASA;EACC,UAAA;EACA,WAAA;AAND;;AASA;EACC,uBAAA;EACA,kBAAA;AAND;;AASA;EACC,0CAAA;EACA,kBAAA;EACA,mBAAA;AAND;;AASA;EACC,oBAAA;EACA,4CAAA;EACA,mBAAA;EACA,kBAAA;AAND;AASA;EACC,yBAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AAPD;AAUA;EACC,SAAA;EACA,8CAAA;EACA,kBAAA;EACA,8BAAA;AARD;;AAWA;EACC,cAAA;EACA,iBAAA;EACA,qBAAA;AARD;;AAWA;;;;;;EAMC,sCAAA;AARD;;AAWA;EACC,cAAA;EACA,cAAA;EACA,wBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AARD;;AAUA;EACC,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAPD;;AASA;EACC,cAAA;EACA,iBAAA;EACA,wBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAND;;AAQA;EACC,cAAA;EACA,wBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AALD;;AAOA;EACC,cAAA;EACA,iBAAA;EACA,wBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAJD;;AAMA;EACC,cAAA;EACA,iBAAA;EACA,wBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAHD;;AAMA;EACC,yBAAA;AAHD;;AAMA;EACC,yBAAA;AAHD;;AAMA;EACC,yBAAA;AAHD;;AAMA;EACC,yBAAA;AAHD;;AAMA,kCAAA;AACA;;;;;;;;;EASC,2DAAA;EACA,+DAAA;EACA,oEAAA;EAAA,4DAAA;AAHD;;AAMA,mCAAA;AACA;EACC,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;AAHD;;AAMA,gBAAA;AAEA;EACC,sBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;EACA,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,eAAA;EACA,oCAAA;EACA,sBAAA;EACA,8CAAA;EACA,uBAAA;EACA,oBAAA;AAJD;;AAOA,cAAA;AAEC;EAAA,iBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,qBAAA;EAAA;AAAA;;AAGD;;EAEC,sCAAA;AAJD;;AAOA;;;;;;EAMC,+CAAA;EACA,4BAAA;AAJD;;AAOA;;EAEC,mBAAA;AAJD;;AAOA;EACC,2BAAA;AAJD;;AAOA;EACC,uBAAA;AAJD;;AAOA,YAAA;AAEA;EACC,WAAA;AALD;;AAQA;EACC;IACC,yBAAA;EALA;AACF;AAQA;EACC;IACC,WAAA;EANA;AACF;AASA,UAAA;AACA;EACC,yCAAA;AAPD;;AAUA,UAAA;AACA;EACC,6BAAA;AAPD;;AASA;EACC,+BAAA;AAND;;AASA;EACC,6BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;AAND;;AASA,UAAA;AACA;EACC,+CAAA;AAND;;AASA;EACC,wBAAA;AAND;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA,iCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA,6BAwRA;EAxRA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA,2FAwRA;EAxRA,+GAwRA;EAxRA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA,+BAwRA;EAxRA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;;EAAA;IAAA,4BAwRA;IAxRA;EAwRA;;EAxRA;IAAA,0BAwRA;IAxRA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA,kCAwRA;IAxRA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA,kCAwRA;IAxRA,sEAwRA;IAxRA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA,6BAwRA;IAxRA;EAwRA;;EAxRA;IAAA,6BAwRA;IAxRA;EAwRA;;EAxRA;IAAA,gCAwRA;IAxRA;EAwRA;AAAA;;AAxRA;;EAAA;IAAA;EAwRA;AAAA;;AAxRA;;EAAA;IAAA;EAwRA;AAAA;;AAxRA;;EAAA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA,+BAwRA;IAxRA;EAwRA;;EAxRA;IAAA,+BAwRA;IAxRA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA,6BAwRA;IAxRA;EAwRA;AAAA;;AAxRA;;EAAA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA,kCAwRA;IAxRA,sEAwRA;IAxRA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA,gCAwRA;IAxRA;EAwRA;;EAxRA;IAAA,8BAwRA;IAxRA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA,0BAwRA;IAxRA;EAwRA;;EAxRA;IAAA,6BAwRA;IAxRA;EAwRA;AAAA;;AAxRA;;EAAA;IAAA,4BAwRA;IAxRA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;AAAA;;AAxRA;;EAAA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA,gCAwRA;IAxRA;EAwRA;AAAA;;AAxRA;;EAAA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;AAAA;;AAxRA;;EAAA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;AAAA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA,8BAwRA;EAxRA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;EAAA,qCAwRA;EAxRA;AAwRA;;AAxRA;;EAAA;IAAA;EAwRA;;EAxRA;IAAA;EAwRA;AAAA;;AAxRA;EAAA,+BAwRA;EAxRA;AAwRA;;AAxRA;EAAA,+BAwRA;EAxRA;AAwRA;;AAxRA;EAAA,+BAwRA;EAxRA;AAwRA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n.striped {\n\ttd {\n\t\t@apply bg-black bg-opacity-20 #{!important};\n\t}\n}\n\n.ant-popover-inner-content,\n.ant-popover-content,\n.ant-popover {\n\t// height: 100px;\n\tmax-width: 280px !important;\n\twidth: 100% !important;\n}\n\n* {\n\toutline: none;\n\tpadding: 0;\n\tbox-sizing: border-box;\n\tscrollbar-width: thin;\n\tscrollbar-color: rgba(155, 155, 155, 0.5) transparent;\n\tfont-family: 'AvenirNext', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',\n\t\t'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n\t\tsans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\n[dir='rtl'] * {\n\tfont-family: 'Vazir', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n\t\t'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n*::-webkit-scrollbar {\n\twidth: 6px;\n\theight: 5px;\n}\n\n*::-webkit-scrollbar-track {\n\tbackground: transparent;\n\tborder-radius: 5px;\n}\n\n*::-webkit-scrollbar-thumb {\n\tbackground-color: rgba(134, 134, 134, 0.5);\n\tborder-radius: 5px;\n\tborder: transparent;\n}\n\n@font-face {\n\tfont-family: 'Vazir';\n\tsrc: url('../fonts/Vazir/Vazirmatn-Medium.ttf');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: 'AvenirNext';\n\tsrc: url('../fonts/avenir-next/AvenirNextLTPro-Regular.otf') format('truetype');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\nbody {\n\tmargin: 0;\n\tbackground-color: var(--dg-body-bg) !important;\n\toverflow-x: hidden;\n\tcolor: var(--dg-primary-color);\n}\n\na {\n\tcolor: inherit;\n\ttransition: unset;\n\ttext-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tcolor: var(--dg-text-color) !important;\n}\n\nh1 {\n\tdisplay: block;\n\tfont-size: 2em;\n\tmargin-top: 0 !important;\n\tmargin-bottom: 0 !important;\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-weight: bold;\n}\nh2 {\n\tdisplay: block;\n\tfont-size: 1.5em;\n\tmargin-top: 0 !important;\n\tmargin-bottom: 0 !important;\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-weight: bold;\n}\nh3 {\n\tdisplay: block;\n\tfont-size: 1.17em;\n\tmargin-top: 0 !important;\n\tmargin-bottom: 0 !important;\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-weight: bold;\n}\nh4 {\n\tdisplay: block;\n\tmargin-top: 0 !important;\n\tmargin-bottom: 0 !important;\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-weight: bold;\n}\nh5 {\n\tdisplay: block;\n\tfont-size: 0.83em;\n\tmargin-top: 0 !important;\n\tmargin-bottom: 0 !important;\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-weight: bold;\n}\nh6 {\n\tdisplay: block;\n\tfont-size: 0.67em;\n\tmargin-top: 0 !important;\n\tmargin-bottom: 0 !important;\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-weight: bold;\n}\n\n.rtl {\n\tdirection: rtl !important;\n}\n\n.rtl-all * {\n\tdirection: rtl !important;\n}\n\n.ltr {\n\tdirection: ltr !important;\n}\n\n.ltr-all * {\n\tdirection: ltr !important;\n}\n\n/* Change the white to any color */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n\t-webkit-text-fill-color: var(--dg-primary-color) !important;\n\t-webkit-box-shadow: 0 0 0px 1000px transparent inset !important;\n\ttransition: background-color 5000s ease-in-out 0s !important;\n}\n\n/* disable password input suggest */\n.dg-input-password {\n\tfont-family: text-security-disc;\n\ttext-security: disc;\n\t-webkit-text-security: disc;\n\t-moz-text-security: disc;\n}\n\n/* date picker */\n\n.rmdp-container {\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tpadding: 0;\n\tfont-variant: tabular-nums;\n\tlist-style: none;\n\tfont-feature-settings: 'tnum', 'tnum';\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 100%;\n\tmin-width: 0;\n\tborder-radius: 16px;\n\tpadding: 4px 11px;\n\tcolor: var(--dg-primary-color);\n\tfont-size: 14px;\n\tbackground-color: var(--dg-input-bg);\n\tbackground-image: none;\n\tborder: 1px solid var(--dg-input-border-color);\n\tborder-radius: 0.375rem;\n\ttransition: all 0.3s;\n}\n\n/* container */\n.container {\n\t@apply mx-auto max-w-[1368px] px-5;\n}\n\n.anticon-eye-invisible,\n.anticon-eye.ant-input-password-icon {\n\tcolor: var(--dg-text-color) !important;\n}\n\n.rmdp-top-class,\n.rmdp-container .bg-dark.ep-arrow::after,\n.bg-dark.rmdp-wrapper,\n.bg-dark .rmdp-month-picker,\n.bg-dark .rmdp-year-picker,\n.bg-dark .rmdp-time-picker div input {\n\tbackground-color: var(--dg-input-bg) !important;\n\tbox-shadow: 0 0 8px 1px #ccc;\n}\n\n.rmdp-top-class,\n.bg-dark.rmdp-wrapper {\n\tborder-radius: 16px;\n}\n\n.rmdp-ep-shadow:after {\n\tbox-shadow: none !important;\n}\n\n.rmdp-container {\n\theight: 50px !important;\n}\n\n/* sidebar */\n\n.responsive-layout {\n\twidth: 100%;\n}\n\n@media (min-width: 969px) {\n\t.responsive-layout {\n\t\twidth: calc(96vw - 282px);\n\t}\n}\n\n@media (min-width: 1643px) {\n\t.responsive-layout {\n\t\twidth: 100%;\n\t}\n}\n\n/* toast */\n.Toastify__toast-container {\n\tz-index: 99999999999999999999 !important;\n}\n\n/* modal */\n.ant-modal-mask {\n\tz-index: 999999999 !important;\n}\n.ant-modal-wrap {\n\tz-index: 99999999999 !important;\n}\n\n#lottie {\n\tbackground-color: transparent;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\toverflow: hidden;\n\ttransform: translate3d(0, 0, 0);\n\ttext-align: center;\n\topacity: 1;\n}\n\n/* crisp */\n#crisp-chatbox {\n\tz-index: 9999999999999999999999999999999999999;\n}\n\n.swiper-slide-shadow-coverflow {\n\tdisplay: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
